import {TUPLA_TYPE} from '../../DoraData/data-base';

/**
 * Necessary information to build a fixed series.
 */
export class FixedSeriesInfo {
  public name: string;
  public value: number;
  public type: TUPLA_TYPE;
  public color: string;
}
